import { render, staticRenderFns } from "./NotificationsGridModal.vue?vue&type=template&id=1801dc00&scoped=true"
import script from "./NotificationsGridModal.vue?vue&type=script&lang=js"
export * from "./NotificationsGridModal.vue?vue&type=script&lang=js"
import style0 from "./NotificationsGridModal.vue?vue&type=style&index=0&id=1801dc00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1801dc00",
  null
  
)

export default component.exports